import React,{useState,useEffect} from 'react';
import EsimSupportingDevices from '../EsimSupportingDevicesBlock/EsimSupportingDevicesComponent';
import VideoPopUpBlock from '../VideoPopUpBlock/VideoPopUpBlock';


function WrapperEsimVideo(props) {
  const iContent = props?.iContent?.mainContentArea?.expandedValue;
  const [isRenderEsimSupportingDevices,setIsRenderEsimSupportingDevices] = useState(false);
  const [isRenderVideoPopUpBlock, setIsRenderVideoPopUpBlock] = useState(false);

  let propsIContentEsim = iContent?.find(({contentType})=> contentType[1] === 'EsimSupportingDevicesBlock');
  let propsIContentVideoPopUp = iContent?.find(({contentType})=> contentType[1] === 'VideoPopUpBlock')


  useEffect(()=>{
      if(props?.iContent?.mainContentArea?.expandedValue?.length >= 1){
        if(propsIContentEsim != undefined)
          setIsRenderEsimSupportingDevices(true)
        if(propsIContentVideoPopUp != undefined)
          setIsRenderVideoPopUpBlock(true)
      }
    },[])

  return (
    <div className='wrapper-esim-video'>
        {isRenderVideoPopUpBlock && 
          <VideoPopUpBlock propsIContent={propsIContentVideoPopUp}></VideoPopUpBlock>
        }
        { isRenderEsimSupportingDevices && 
          <EsimSupportingDevices propsIContent={propsIContentEsim} context={props.context}></EsimSupportingDevices>
        }
    </div>
  )
}

export default WrapperEsimVideo